export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL";

export const MARK_NOTIFICATIONS_REQUEST = "MARK_NOTIFICATIONS_REQUEST";
export const MARK_NOTIFICATIONS_SUCCESS = "MARK_NOTIFICATIONS_SUCCESS";
export const MARK_NOTIFICATIONS_RESET = "MARK_NOTIFICATIONS_RESET";
export const MARK_NOTIFICATIONS_FAIL = "MARK_NOTIFICATIONS_FAIL";

export const MARK_ALL_AS_READ_REQUEST = "MARK_ALL_AS_READ_REQUEST";
export const MARK_ALL_AS_READ_SUCCESS = "MARK_ALL_AS_READ_SUCCESS";
export const MARK_ALL_AS_READ_RESET = "MARK_ALL_AS_READ_RESET";
export const MARK_ALL_AS_READ_FAIL = "MARK_ALL_AS_READ_FAIL";

export const DELETE_ALL_NOTIFCATIONS_REQUEST = "DELETE_ALL_NOTIFCATIONS_REQUEST";
export const DELETE_ALL_NOTIFCATIONS_SUCCESS = "DELETE_ALL_NOTIFCATIONS_SUCCESS";
export const DELETE_ALL_NOTIFCATIONS_RESET = "DELETE_ALL_NOTIFCATIONS_RESET";
export const DELETE_ALL_NOTIFCATIONS_FAIL = "DELETE_ALL_NOTIFCATIONS_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";
